import { ICancelarRecebimentoUseCase } from "../../../presentation/useCases/update/cancelar_recebimento_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CancelarRecebimentoUseCase
 */

export class CancelarRecebimentoUseCase implements ICancelarRecebimentoUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async cancelarRecebimento(idContaReceber: number): Promise<void> {
    await this.repository.cancelarRecebimento(idContaReceber);
  }
}
